// @ts-strict-ignore
import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import React from "react";
import {
  CoinPostsCardContainer,
  CoinPostsListItemContentContainer,
  CoinPostsListItemTitle,
  CoinPostsCardStyled
} from "./styles";
import { Flex, List, ListItem, SkeletonLoader, Text } from "@hubble/web";
import { useConverterPageContext } from "utils/converter-provider";
import type { BlogContentType } from "types/blog-type";
import { ContentfulResponsiveImage } from "components/common/image/ContentfulResponsiveImage";
import NextLink from "components/parts/NextLink";
import { web } from "@hubble/tokens";

const RenderListItem = ({
  title,
  slug,
  image,
  name,
  readTime
}: BlogContentType) => {
  return (
    <NextLink href={slug || "#"} id={`register-blog-${title}`} newTab={true}>
      <ListItem>
        <CoinPostsListItemContentContainer>
          {image?.url && (
            <ContentfulResponsiveImage
              priority
              alt={image?.altText}
              sizes={[
                {
                  media: "(min-width: 100px)",
                  src: image?.url,
                  height: 80,
                  width: 144
                }
              ]}
            />
          )}
          <Flex flexDirection="column">
            <CoinPostsListItemTitle
              title={title}
              size="sm"
              fontWeight={400}
              m={0}
            >
              {title}
            </CoinPostsListItemTitle>
            <Text.Body
              size="sm"
              fontWeight={400}
              m={0}
              color={web.color.base.gray[600]}
            >
              {name} • {readTime?.text}
            </Text.Body>
          </Flex>
        </CoinPostsListItemContentContainer>
      </ListItem>
    </NextLink>
  );
};
const CoinPostsCard: React.FC = () => {
  const { isRouting } = useConverterPageContext();
  const t = useTranslations(FILES.CONVERTER);
  const { assetPrice, decoratedCoinRelatedPosts = [] } =
    useConverterPageContext();
  const coinName = assetPrice?.toDisplayName ?? "--";

  return (
    <CoinPostsCardContainer>
      {isRouting ? (
        <SkeletonLoader width="50%" height="24px" />
      ) : (
        <Text.Heading size="xs" as="h2" marketing>
          {t("postsCardTitle", {
            name: coinName
          })}
        </Text.Heading>
      )}
      <CoinPostsCardStyled p={0} mt={2}>
        <Flex alignItems="center" height="100%">
          {!isRouting ? (
            <List pl={0} mt={0} mb={0}>
              {decoratedCoinRelatedPosts.map(
                (item: BlogContentType, index: number) => {
                  return <RenderListItem key={index} {...item} />;
                }
              )}
            </List>
          ) : (
            <SkeletonLoader width="100%" height="100%" />
          )}
        </Flex>
      </CoinPostsCardStyled>
    </CoinPostsCardContainer>
  );
};

export default CoinPostsCard;
